/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcRegistrationV1AccountQueryServiceAccountGetAccountGetRequest, IxcRegistrationV1AccountQueryServiceAccountGetResponse } from '@interxfi/types';

export const IXC_REGISTRATION_V1_ACCOUNT_QUERY_SERVICE_ACCOUNT_GET_AUDIENCE = ['clearing', 'program'];

export async function ixcRegistrationV1AccountQueryServiceAccountGet(baseUrl: string | undefined, request?: IxcRegistrationV1AccountQueryServiceAccountGetAccountGetRequest, requestInit?: RequestInit): Promise<IxcRegistrationV1AccountQueryServiceAccountGetResponse | undefined> { return makeRequest<IxcRegistrationV1AccountQueryServiceAccountGetResponse, IxcRegistrationV1AccountQueryServiceAccountGetAccountGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/registration/v1/account/q/:accountId', request, requestInit)); }

